import Setup from "views/Setup.jsx";
import Switches from "views/Switches.jsx";
import Alerts from "views/Alerts.jsx";
import Settings from "views/Settings.jsx"
/*import Help from "views/Help.jsx"
import Dashboard from "views/Dashboard.jsx";*/
import PlansPage from "views/PlansPage.jsx";
import Storages from "views/Storages.jsx";
import Profile from "views/Profile.jsx";
import Privacy from "views/Privacy.jsx";
import Tos from "views/Tos.jsx";
import Map from "views/Map.jsx";
import Admin from "views/Admin";
import Checkout from "views/Checkout";

const routes = [
  {
    path: "/plans",
    name: "plans",
    icon: "tim-icons icon-basket-simple",
    component: PlansPage
  },
  {
    path: "/setup",
    name: "setup",
    icon: "tim-icons icon-settings",
    component: Setup,
    hidden: false
  },
  {
    path: "/settings",
    name: "settings",
    icon: "tim-icons icon-settings-gear-63",
    component: Settings,
    hidden: false
  },
  {
    path: "/switches",
    name: "switches",
    icon: "tim-icons icon-button-power",
    component: Switches,
    hidden: false
  },
  {
    path: "/alarms",
    name: "alarms",
    icon: "tim-icons icon-bell-55",
    component: Alerts,
    hidden: false
  },
  {
    path: "/storages",
    name: "storages",
    icon: "tim-icons icon-tv-2",
    component: Storages,
    hidden: false
  },
  {
    path: "/map",
    name: "map",
    icon: "tim-icons icon-map-big",
    component: Map,
    hidden: false
  },
  {
    path: "/wiki",
    name: "wiki",
    icon: "tim-icons icon-support-17",
    hidden: false
  },
  {
    path: "/admin",
    name: "admin",
    icon: "tim-icons icon-laptop",
    component: Admin,
    hidden: true
  },
  {
    path: "/profile",
    name: "profile",
    icon: "",
    component: Profile,
    hidden: true
  },
  {
    path: "/privacy",
    name: "privacy",
    icon: "",
    hidden: true
  },
  {
    path: "/tos",
    name: "tos",
    icon: "",
    hidden: true
  },
  {
    path: "/checkout",
    name: "checkout",
    icon: "",
    component: Checkout,
    hidden: true
  },/*,
  {
    path: "/help",
    name: "help",
    icon: "tim-icons icon-pin",
    component: Help,
  },*/
  /*{
    path: "/dashboard",
    name: "dashboard",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
  }*/
];

export default routes;
